module.exports = __webpack_public_path__ + "img/rodlog.0c1bcff9.jpg";